/*System Core*/
import { postRequest } from "../Requests/PostFetch";
import cfJS from "./cfJS";

class EngineClass {

    constructor() {
        this.id = 0;

        //cache to uploadJs
        this.alreadyUploadJSFile = {};

        //common request headers to send in requests
        this.commonRequestHeaders = {};

        /*
        * widgets control
        */
        this.widgetsList = {
            arr: {},
            add: function (name, link) {
                if (!this.arr[name])
                    this.arr[name] = link;
            },
            get: function (name) {
                if (this.arr[name])
                    return this.arr[name];
            }
        };
    }

    /*
    * connect to nodejs server socket
    */
    ConnectToSocket() {
        let that = this;

        this.uploadJS(["http://wtsdev.loc:3000/socket.io/socket.io.js"], function () {
            that.socket = io.connect('http://wtsdev.loc:3000/');

            that.socket.on('connect', function () {
                console.log('connect');
            });

            that.socket.on('message', function (msg) {
                console.log(msg);
            });

            that.socket.on('test', function (msg) {
                console.log("test");
            });

            that.socket.on('disconnect', function () {
                console.log('disconnected');
            });

            that.socket.on('error', function (data) {
                console.log(data || 'error');
            });
        });

    }

    /*
    * dunamic upload js files
    */
    uploadJS(arr, func) { //Загрузчик js-файлов
        let that = this;

        if (!arr || !func)
            return;

        function loadJSFile(num) {
            if (that.alreadyUploadJSFile[arr[num]]) {
                if (arr[num + 1])
                    loadJSFile(num + 1);
                else
                    func();
                return;
            }

            let head = document.getElementsByTagName('head')[0];
            let loadedJS = document.createElement('script');
            loadedJS.type = 'text/javascript';

            loadedJS.onload = function () {
                if (arr[num + 1])
                    loadJSFile(num + 1);
                else
                    func();
            };

            that.alreadyUploadJSFile[arr[num]] = true;
            loadedJS.src = arr[num];
            head.appendChild(loadedJS);
        }

        loadJSFile(0);
    }

    // adding a common Request Header that will be sent along with the request
    addCommonRequestHeader(key, value) {
        this.commonRequestHeaders[key] = value;
    }
    // removing the common Request Header
    removeCommonRequestHeader(key) {
        delete this.commonRequestHeaders[key];
    }

    ReturnComponentId() {
        return this.id + 1;
    }

    Manager(className, dom) {
        return new window[className](dom);
    }

    RenderComponent(dom, template, values) {
        template = template.replace(/{{[A-Za-z0-9\.]{1,}}}/g, (val) => {
            return values[val.substr(2, val.length - 4)];
        });

        dom.innerHTML = template;
    }

    //Request generator param
    _generateStringFromObject(obj) {
        let str = "";
        for (let i in obj) {
            if (str)
                str += "&";
            str += i + "=" + obj[i];
        }
        return str;
    }

    /*
    * get XML Http object
    */
    getXmlHttp() {
        let xmlHttp;
        if (window.XMLHttpRequest) {
            xmlHttp = new XMLHttpRequest();
        } else if (window.ActiveXObject) {

            try {
                xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
            } catch (e) {
                xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
            }

        }

        return xmlHttp;
    }

    /*
     * send get request on server (not tested)
     */
    getRequest(url, params, callback, headers) {
        let xhr = this.getXmlHttp();

        xhr.open('GET', params ? url + "?" + this._generateStringFromObject(params) : url, true);

        for (let i in this.commonRequestHeaders)
            xhr.setRequestHeader(i, this.commonRequestHeaders[i]);

        for (let i in headers)
            xhr.setRequestHeader(i, headers[i]);

        xhr.send();

        xhr.onreadystatechange = function (param) {
            if (xhr.readyState != 4) return;

            if (xhr.status != 200)
                callback(xhr.status + ': ' + xhr.statusText);
            else {
                callback(xhr.responseText);
            }
        }
    }

    /*
    * send post request on server (usability)
    */
    async postRequest(url, params, callback, headers) {

        const request = await postRequest(url, params, headers, this.commonRequestHeaders);

        callback(request.data, request.status);

        /*let xhr = this.getXmlHttp();

        //create data
        let formData = new FormData();

        for (let i in params)
            formData.append(i, params[i]);

        xhr.open('POST', url, true);

        for (let i in this.commonRequestHeaders)
            xhr.setRequestHeader(i, this.commonRequestHeaders[i]);

        for (let i in headers)
            xhr.setRequestHeader(i, headers[i]);

        if (headers && headers['Content-Type']==='application/json')
            xhr.send(JSON.stringify(params));
        else
            xhr.send(formData);

        xhr.onreadystatechange = function () {
            if (xhr.readyState != 4) return;

            if (xhr.status != 200)
                callback(xhr.status + ': ' + xhr.statusText, xhr.status);
            else
                callback(xhr.responseText, xhr.status);
        }*/
    }

    /*
    * get all pages fields value from dom elements
    */
    getPagesFieldsValue(form) {
        let fields = document.querySelectorAll("input,select,textarea"),
            value = {},
            pos = 0,
            engn = this;

        //Set value to response array
        function _setValue(dom, valueArr) {
            if (dom.hasAttribute("readonly"))
                return;

            let name = dom.getAttribute("name") || dom.getAttribute("id");
            if (!name) {
                console.warn("One of the fields don't have name or id", dom);
                name = "unknown_field_" + pos;
                pos++;
            }

            if (dom.getAttribute("type") == "file") {
                let fileWidget = engn.widgetsList.get(dom.getAttribute("id"));

                if (fileWidget)
                    if (typeof fileWidget.getValue() === "string") { //#1612
                        valueArr[name] = fileWidget.getValue();
                        return;
                    }

                try {
                    let files = [];

                    if (fileWidget)
                        files = fileWidget.getValue();

                    if (files) {
                        if (files.length > 1) {
                            for (let i = 0; i < files.length; i++) {
                                valueArr[name + "_" + i] = files[i];
                            }
                        } else
                            valueArr[name] = files;
                    }
                } catch (e) {
                    console.log(e);
                }

                return;
            }

            if (dom.getAttribute("type") == "checkbox") {
                valueArr[name] = dom.checked;
                return;
            }

            valueArr[name] = dom.value;
        }

        if (!form)
            for (let i = 0; i < fields.length; i++) {
                _setValue(fields[i], value);
                //let dom = fields[i];
                //value[dom.getAttribute("name")] = dom.value;
            }
        else {
            //Take only hidden fields
            for (let i = 0; i < fields.length; i++) {
                let dom = fields[i];
                if (dom.getAttribute("type") == "hidden")
                    value[dom.getAttribute("name")] = dom.value;
            }

            fields = form.querySelectorAll("input,select,textarea");

            for (let i = 0; i < fields.length; i++) {
                _setValue(fields[i], value);
                //let dom = fields[i];
                // Why it's commented by Ruslan Valuyskiy?
                // Because, if we have two or more forms on page with same hidden elements than
                // would be responded the last one
                // if (!value[dom.getAttribute("name")])
                //value[dom.getAttribute("name")] = dom.value;
            }
        }

        return value;
    }
    /*
    * Go to page (redirect)
    * Перевести на конкретную страницу
    */
    href(uri) {
        window.location = uri;
    }
    /*
    * Redirect to some page
    * */
    location(href) {
        parent.document.location.href = String(href);
    }
    /*
    * Parse answer from post/get request
    * Распрсить ответ с сервера
    */
    parseRequestAnswer(response) {
        const that = this;

        try {
            var response = JSON.parse(response);
        } catch (e) {
            new Notice("500: Error request", "error");
            console.log(response);
            return;
        }

        if (response.result == "success") {
            if (String(response.message))
                new Notice(String(response.message));

            if (response.reload) {
                if (!String(response.message)) {
                    parent.document.location.reload();
                } else {
                    setTimeout(function () {
                        parent.document.location.reload();
                    }, 1000);
                }
            }

            //redirect to url
            if (response.redirect) {
                if (!String(response.message)) {
                    that.location(response.redirect);
                } else {
                    setTimeout(function () {
                        that.location(response.redirect);
                    }, 1000);
                }
            }
        } else {
            if (String(response.message))
                new Notice(response.message, "error");

            //error field validataion
            if (String(response.field))
                cfJS.appendValidationError(String(response.field));

            if (response.reload)
                setTimeout(function () {
                    parent.document.location.reload();
                }, 1000);

            //redirect to url
            if (response.redirect) {
                if (!String(response.message)) {
                    that.location(response.redirect);
                } else {
                    setTimeout(function () {
                        that.location(response.redirect);
                    }, 1000);
                }
            }
        }

        return response;
    }
}

let Engine = new EngineClass();

export default Engine;